<div class="main-video" *ngFor="let item of liveVideos" [mtgHeightRatio]="1.77">
  <iframe
    *ngIf="item.videoUrl"
    [src]="item.videoUrl | safe: 'resourceUrl'"
    frameborder="0"
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
  ></iframe>
</div>

<ng-container *ngIf="videos && videos.length > 0">
  <div class="title">Моменты игры</div>
  <div class="videos">
    <div class="video" *ngFor="let item of videos" [mtgHeightRatio]="1.77">
      <iframe
        *ngIf="item.videoUrl"
        [src]="item.videoUrl | safe: 'resourceUrl'"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</ng-container>
